import Vue from 'vue'
import Router from 'vue-router'
import {layout, route,} from '@/util/routes'

Vue.use(Router)

const DEFAULT = 'Nexomed';

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) return {selector: to.hash}
        if (savedPosition) return savedPosition
        return {x: 0, y: 0}
    },
    routes: [
        layout('Default', [
            route('Login', null, '/', {title: 'Login'}),
            route('Inicio', null, 'inicio', {title: 'Início', jwt: true}),
            route('Usuarios', null, 'usuarios', {title: 'Usuários', jwt: true}),
            route('ClientesInicio', null, 'clientes', {title: 'Clientes - Início', jwt: true}),
            route('ClienteNew', null, 'cliente', {title: 'Cliente - Cadastro', jwt: true}),
            route('ClienteEdit', null, 'cliente/:id', {title: 'Cliente - Edição', jwt: true}),
            route('ClienteAcompanhamento', null, 'acompanhamento/:id', {title: 'Acompanhamento', jwt: true}),
            route('Receber', null, 'receber', {title: 'Títulos/Contas a Receber', jwt: true}),
            route('ClienteSinalizacao', null, 'cliente/:id/sinalizar', {title: 'Sinalizar Cliente', jwt: true}),
            route('ContratoInicio', null, 'contratos', {title: 'Contratos - Início', jwt: true}),
            route('ContratoNew', null, 'contrato', {title: 'Contratos - Cadastro', jwt: true}),
            route('ContratoEdit', null, 'contratos/:id', {title: 'Contratos - Edição', jwt: true}),
        ]),
    ],
})

const rotasOcultas: Array<any> = [];

router.beforeEach((to: any, from: any, next: any) => {
    const result = router.resolve({path: to.path});
    // Verifica se a rota está na lista de rotas ocultas,
    // caso sim ele é redirecionado para a Tela de Login
    if (rotasOcultas.find((rota) => rota === to.name)
        && (!to.params.hide || to.params.hide === false)) {
        next({path: '/'});
    } else if (result.resolved.matched.length <= 0) {
        next({path: '/'});
    } else if (to.meta.jwt) {
        // Verifica se a rota precisa de autenticação
        // Verifica se o JWT está preenchido
        if (localStorage.jwt == null) {
            // Atribui a Rota de login o que ele queria acessar anteriormente
            const laRota = router.resolve({path: '/',});
            if (router != undefined && laRota?.resolved?.meta !== undefined) {
                laRota.resolved.meta.redirect = to.fullPath
            }
            // Redireciona para a tela de Login
            next({path: '/'});
            // Verifica que o jwt está preenchido
        } else if (localStorage.jwt) {
            next();
        }
    } else {
        if (localStorage.jwt) {
            next({path: '/inicio'});
        }
        next();
    }
});

router.afterEach((to, from) => {
    Vue.nextTick(() => {
        if (to && to.meta && to.meta.title) {
            document.title = `${to.meta.title} | ${DEFAULT}`;
        } else {
            document.title = `${DEFAULT}`;
        }
    });
    // @ts-ignore
    if (to.params.hide === true) {
        to.params.hide = 'false';
    }
});

// router.beforeEach((to, from, next) => {
//     return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
// })

export default router
